<template>
  <div id="modalEditTimeline" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Editar Cronograma</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            title="Fechar"
            @click="$emit('closeModal', false)"
          />
        </div>
        <form @submit.prevent="save">
          <div v-if="data.step" class="modal-body pb-0">
            <div>
              <p>
                <strong>Atividade:</strong> {{ data.step.order }} -
                {{ data.step.title }}
              </p>
              <p><strong>Detalhamento:</strong> {{ data.step.description }}</p>
            </div>
            <hr class="mt-1 mb-2" />
            <div class="row align-items-center">
              <div class="col-5 my-2">
                <div
                  class="form-check form-check-inline form-switch form-check-reverse"
                >
                  <input
                    type="checkbox"
                    id="timelineActive"
                    class="form-check-input cursor-pointer"
                    true-value="1"
                    false-value="0"
                    :checked="data.timeline.active == 1"
                    v-model="data.timeline.active"
                  />
                  <label class="form-check-label" for="timelineActive">
                    Atividade será executada no mês
                    <strong>{{ data.timeline.period }}</strong>
                  </label>
                </div>
              </div>
              <div class="col-3">
                <p class="mb-0">
                  Acumulado:
                  {{
                    this.data.percentTimeline ? this.data.percentTimeline : 0
                  }}%
                </p>
              </div>
              <div v-show="data.timeline.active == 1" class="col-4">
                <div class="row align-items-center">
                  <label class="col-form-label col-lg-6 text-center">
                    % Programado: <span class="text-danger">*</span>
                  </label>
                  <div class="col-lg-6">
                    <div class="input-group input-group-sm">
                      <input
                        type="number"
                        class="form-control form-control-number text-center"
                        step="0.01"
                        v-model="data.timeline.percent"
                        @change="validatePercenteTimeline"
                      />
                      <span class="input-group-text">%</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr class="mt-1 mb-2" />
            <div class="row mb-2">
              <div class="col-lg-12 text-center">
                <h6 class="text-center">Responsabilidades</h6>
                <h5
                  class="text-success"
                  :class="{ 'text-danger': data.percentResponsible != 100 }"
                >
                  {{ data.percentResponsible }}%
                </h5>
              </div>
              <div
                class="col-lg-6 border-end border-end-width-1 border-end-secondary"
              >
                <p class="text-center"><strong>Proponentes</strong></p>
                <div class="row">
                  <div
                    v-for="responsibleBidder in data.responsibleBidders"
                    :key="responsibleBidder.id"
                    class="d-flex flex-column"
                    :class="{ 'col-lg-6': data.responsibleBidders.length > 1 }"
                  >
                    <label class="col-form-label text-center">
                      {{ responsibleBidder.name }}
                    </label>
                    <input
                      type="number"
                      class="form-control form-control-sm form-control-number text-center"
                      step="0.01"
                      v-model="responsibleBidder.percent"
                      @change="validatePercenteBidder(responsibleBidder)"
                    />
                  </div>
                </div>
              </div>
              <div
                class="col-lg-6 border-start border-start-width-1 border-start-secondary"
              >
                <p class="text-center"><strong>Parceiros</strong></p>
                <div class="row">
                  <div
                    v-for="responsiblePartner in data.responsiblePartners"
                    :key="responsiblePartner.id"
                    class="d-flex flex-column"
                    :class="{ 'col-lg-6': data.responsiblePartners.length > 1 }"
                  >
                    <label class="col-form-label text-center">
                      {{ responsiblePartner.name }}
                    </label>
                    <input
                      type="number"
                      class="form-control form-control-sm form-control-number text-center"
                      step="0.01"
                      v-model="responsiblePartner.percent"
                      @change="validatePercentePartner(responsiblePartner)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer border-top-0">
            <button
              type="button"
              class="btn btn-sm btn-link"
              data-bs-dismiss="modal"
              title="Cancelar"
              @click="$emit('closeModal', false)"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="btn btn-sm btn-primary"
              title="Salvar"
              :disabled="disableButton"
            >
              Salvar
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { showModal, hideModal } from '@/utils/modal'
import TypeBidderPartnerEnum from '@/enum/typeBidderPartnerEnum'

export default {
  name: 'EditTimelineModal',

  props: {
    projectId: {
      type: String,
      required: true,
    },
    timelineId: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      disableButton: false,
      data: {},
    }
  },

  watch: {
    data: {
      handler(newVal, oldVal) {
        if (newVal.timeline) {
          if (
            (Number(newVal.timeline.active) === 0 ||
              (Number(newVal.timeline.active) === 1 &&
                newVal.timeline.percent !== '' &&
                newVal.timeline.percent !== null)) &&
            Number(newVal.percentResponsible) === 100
          ) {
            this.disableButton = false
          } else {
            this.disableButton = true
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    async getProjectTimeline() {
      try {
        this.data = await this.$store.dispatch('getProjectTimeline', {
          projectId: this.projectId,
          timelineId: this.timelineId,
        })
        showModal('modalEditTimeline')
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
        this.$emit('closeModal', false)
      }
    },

    validatePercenteTimeline() {
      const percentTotal = 100

      const currentPercentTotalAfterChange =
        this.data.percentTimeline + this.data.timeline.percent

      if (currentPercentTotalAfterChange > percentTotal) {
        this.$root.$refs.notification.warning(
          `O valor deve ser até ${(
            percentTotal - this.data.percentTimeline
          ).toFixed(2)}%`,
        )
        this.data.timeline.percent = null
      }
    },

    validatePercenteBidder(stepResponsibleBidder) {
      this.validatePercentResponsible(
        stepResponsibleBidder,
        TypeBidderPartnerEnum.BIDDER,
      )
    },

    validatePercentePartner(stepResponsiblePartner) {
      this.validatePercentResponsible(
        stepResponsiblePartner,
        TypeBidderPartnerEnum.PARTNER,
      )
    },

    validatePercentResponsible(stepResponsible, typeResponsible) {
      const percentTotal = 100

      const percentResponsibleBidders = this.data.responsibleBidders
        .map((responsibleBidder) => Number(responsibleBidder.percent))
        .reduce((accumulator, currentValue) => accumulator + currentValue, 0)

      const percentResponsiblePartners = this.data.responsiblePartners
        .map((responsiblePartner) => Number(responsiblePartner.percent))
        .reduce((accumulator, currentValue) => accumulator + currentValue, 0)

      const currentPercentTotal =
        percentResponsibleBidders +
        percentResponsiblePartners -
        Number(stepResponsible.percent)

      const currentPercentTotalAfterChange =
        percentResponsibleBidders + percentResponsiblePartners

      if (currentPercentTotalAfterChange > percentTotal) {
        this.$root.$refs.notification.warning(
          `O valor deve ser até ${(percentTotal - currentPercentTotal).toFixed(
            2,
          )}%`,
        )

        if (TypeBidderPartnerEnum.BIDDER === typeResponsible) {
          this.data.responsibleBidders = this.data.responsibleBidders.map(
            (bidder) => {
              if (bidder.id === stepResponsible.id) {
                return { ...bidder, percent: null }
              }
              return bidder
            },
          )
        }
        if (TypeBidderPartnerEnum.PARTNER === typeResponsible) {
          this.data.responsiblePartners = this.data.responsiblePartners.map(
            (partner) => {
              if (partner.id === stepResponsible.id) {
                return { ...partner, percent: null }
              }
              return partner
            },
          )
        }

        this.data.percentResponsible = currentPercentTotal
        return false
      }

      this.data.percentResponsible = currentPercentTotalAfterChange
      return true
    },

    async save() {
      try {
        this.disableButton = true

        const response = await this.$store.dispatch('updateProjectTimeline', {
          projectId: this.projectId,
          timelineId: this.timelineId,
          data: {
            active: this.data.timeline.active,
            percent: this.data.timeline.percent,
            responsibleBidders: this.data.responsibleBidders,
            responsiblePartners: this.data.responsiblePartners,
          },
        })

        this.$root.$refs.notification.success(response.message)

        hideModal()
        this.$emit('closeModal', true)
      } catch (error) {
        this.disableButton = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.getProjectTimeline()
  },
}
</script>
